import React from 'react';
import { Tooltip as KendoTooltip } from '@progress/kendo-react-tooltip';

/**
 * @component
 * @see {@link https://www.telerik.com/kendo-react-ui/components/tooltip| KendoReact Tooltip Documentation}
 *
 * @description Tooltip - A reusable Tooltip wrapper for KendoReact Tooltip.
 *
 * Usage:
 * <Tooltip content="Tooltip text">
 *   <Button ... />
 * </Tooltip>
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - The element to wrap with the tooltip.
 * @param {string|function} props.content - The tooltip content (string or render function).
 * @param {string} [props.anchorElement] - The selector for the anchor element.
 * @param {number} [props.openDelay] - Delay in ms before showing the tooltip.
 * @param {boolean} [props.parentTitle] - Whether to use the parent title attribute.
 * @param {string} [props.position] - Tooltip position (e.g., 'top', 'bottom', 'left', 'right').
 * @param {boolean} [props.showCallout] - Whether to show the tooltip callout arrow.
 * @param {object} [props.tooltipProps] - Additional props for Kendo Tooltip.
 */
export const Tooltip = ({
  children,
  content,
  anchorElement,
  openDelay = 100,
  parentTitle = true,
  position = 'top',
  showCallout = true,
  tooltipProps = {}
}) => (
  <KendoTooltip
    {...(anchorElement ? { anchorElement } : {})}
    openDelay={openDelay}
    parentTitle={parentTitle}
    position={position}
    showCallout={showCallout}
    {...tooltipProps}
    content={typeof content === 'function' ? content : () => content}
  >
    {children}
  </KendoTooltip>
);
